// src/padplanner/planNotices.js
//
// New plan's handoff to the plan page. Create is one click but up to three
// requests (the plan, then the pad, then the imagery pin). When a later step
// fails, the plan exists and the plan page opens, and it has to say exactly
// what was saved and what was not. That sentence is left here for the plan
// page to pick up, keyed by plan id, in memory only: a reload loses it, which
// is right, because the page then shows the plan as it is.

const notices = new Map();

export function leaveNotice(planId, text) {
  notices.set(planId, text);
}

/** The notice for this plan, or null. It stays until dropNotice. */
export function peekNotice(planId) {
  return notices.get(planId) ?? null;
}

export function dropNotice(planId) {
  notices.delete(planId);
}

const sentence = (t) => (/[.!?]$/.test(t.trim()) ? t.trim() : `${t.trim()}.`);

function andList(items) {
  if (items.length <= 1) return items.join("");
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
}

/**
 * What New plan says when a step after the first fails, or null when every
 * step succeeded (the plan page then needs no explanation).
 *
 * @param {string} planNumber
 * @param {{perimeter: boolean, wells: number}} saved     what the server holds now
 * @param {{step: 'pad'|'imagery', reason: string}|null} failure
 * @param {boolean} imageryChosen   an imagery pin was asked for
 */
export function createNotice(planNumber, saved, failure, imageryChosen) {
  if (!failure) return null;
  const parts = ["its details"];
  if (saved.perimeter) parts.push("perimeter");
  if (saved.wells) parts.push(saved.wells === 1 ? "1 well" : `${saved.wells} wells`);
  const head = `${planNumber} was created with ${andList(parts)}.`;
  if (failure.step === "pad") {
    return `${head} The perimeter from the detected pad was not saved: ${sentence(failure.reason)}` +
      (imageryChosen ? " The imagery was not pinned either, because a pin needs a saved perimeter." : "");
  }
  return `${head} The imagery pin was not saved: ${sentence(failure.reason)}`;
}
